import * as Sentry from "@sentry/browser";
import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { Chat, getOptionTitle, Message } from "sweet-global";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const MessageWrapper = styled.div<{ sent: boolean }>`
  display: flex;
  flex-direction: ${props => (props.sent ? "row-reverse" : "row")};
  align-self: ${props => (props.sent ? "flex-end" : "flex-start")};
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 18px;
  padding: 0 30px;
`;

const MessageImageWrapper = styled.div<{ sent: boolean }>`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  margin-left: ${props => (props.sent ? 15 : 0)}px;
  margin-right: ${props => (props.sent ? 0 : 15)}px;
  background-color: ${colors.lighterGray};
`;

const MessageImage = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  outline: none;
  border: none;
`;

const MessageImagePlaceholder = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.gray};
  text-align: center;
`;

const MessageContent = styled.div`
  padding: 10px 15px;
  border-radius: 5px;
  /* box-shadow: rgba(0, 0, 0, 0.08) 0 3px 10px 0; */
  background-color: ${colors.nearWhite};
  width: auto;
  margin-bottom: 20px;
  position: relative;
`;

const MessageText = styled.h4`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.nearBlack};
`;

const MessageTime = styled.p<{ sent: boolean }>`
  font-size: 12px;
  font-weight: 400;
  color: ${colors.gray};
  position: absolute;
  bottom: -20px;
  white-space: nowrap;
  ${props => (props.sent ? "right: 0;" : "left: 0;")}
`;

type OwnProps = {
  chat: Chat;
  message: Message;
  uid: string;
};
type Props = OwnProps & ConnectedProps<typeof connector>;
const ChatMessage: React.FC<Props> = props => {
  try {
    const {
      message,
      uid,
      chat,
      userImage,
      userInitials,
      otherUserImage,
      otherUserInitials,
      venue
    } = props;

    if (!message) return null;

    if (message.type === "MESSAGE") {
      return (
        <MessageWrapper sent={message.from === uid}>
          <MessageImageWrapper sent={message.from === uid}>
            {message.from === uid ? (
              userImage ? (
                <MessageImage src={userImage} />
              ) : (
                <MessageImagePlaceholder>
                  {userInitials}
                </MessageImagePlaceholder>
              )
            ) : otherUserImage ? (
              <MessageImage src={otherUserImage} />
            ) : (
              <MessageImagePlaceholder>
                {otherUserInitials}
              </MessageImagePlaceholder>
            )}
          </MessageImageWrapper>
          <MessageContent>
            <MessageText>{message.message}</MessageText>

            <MessageTime sent={message.from === uid}>
              {moment
                .duration(moment.unix(message.time).diff(moment()))
                .days() > 1
                ? moment.unix(message.time).format("ddd, MMM Do, h:mm A ")
                : moment.unix(message.time).fromNow()}
            </MessageTime>
          </MessageContent>
        </MessageWrapper>
      );
    } else {
      // status message
    }
  } catch (error) {
    Sentry.captureException(error);
    console.error(error);

    return null;
  }
};

const mapState = (state: RootState, ownProps: OwnProps) => ({
  venue: selectors.getVenue(ownProps.chat.venue)(state),
  userImage: selectors.userImage(state),
  userInitials: selectors.userInitials(state),
  otherUserImage: selectors.otherChatUserImage(ownProps.chat.id)(state),
  otherUserInitials: selectors.otherChatUserInitials(ownProps.chat.id)(state)
});
const connector = connect(mapState);

export default connector(ChatMessage);
